import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const TOOLTIP_W = 288;

export default function InfoTooltip({ description, anchor, iconClassName = "h-3.5 w-3.5" }) {
  const [pos, setPos] = useState(null);
  const iconRef = useRef(null);

  const show = (e) => {
    e.stopPropagation();
    const r = e.currentTarget.getBoundingClientRect();
    const above = r.top >= 120;

    let left = r.left + r.width / 2 - TOOLTIP_W / 2;
    if (left + TOOLTIP_W > window.innerWidth - 8) left = r.right - TOOLTIP_W;
    left = Math.max(8, left);

    setPos({ left, above, anchorTop: r.top, anchorBottom: r.bottom });
  };

  // close on any scroll
  useEffect(() => {
    if (!pos) return;
    const hide = () => setPos(null);
    window.addEventListener("scroll", hide, true);
    return () => window.removeEventListener("scroll", hide, true);
  }, [pos]);

  return (
    <span
      ref={iconRef}
      className="relative flex-shrink-0"
      onMouseEnter={show}
      onMouseLeave={() => setPos(null)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`cursor-default transition-colors ${iconClassName} ${pos ? "text-slate-600" : "text-slate-400"}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>

      {pos && createPortal(
        <div
          className="fixed z-[10001] w-72 rounded-lg border border-[#1E5B4F] bg-[#F0F5F0] p-3 text-sm leading-snug text-slate-700 shadow-xl ring-1 ring-[#1E5B4F]/20"
          style={
            pos.above
              ? { bottom: window.innerHeight - pos.anchorTop + 8, left: pos.left }
              : { top: pos.anchorBottom + 8, left: pos.left }
          }
        >
          {description}
          {anchor && (
            <p className="mt-1.5 text-xs italic text-slate-500">{anchor}</p>
          )}
        </div>,
        document.body
      )}
    </span>
  );
}
